import { TeamTranslate } from './teamTranslate.model';

const teamTranslatePTBR: TeamTranslate = {
  page: {
    title: 'Equipe',
    subtitle: 'Gerencie quem tem acesso a este estúdio.',
  },
  inviteCta: 'Convidar membro',
  members: {
    title: 'Membros',
    emptyState: 'Nenhum membro ainda.',
    ownerBadge: 'Dono',
    youBadge: 'Você',
  },
  pendingInvitations: {
    title: 'Convites pendentes',
    emptyState: 'Nenhum convite pendente.',
    expiresAt_one: 'Expira em 1 dia',
    expiresAt_other: 'Expira em {{count}} dias',
    expiredLabel: 'Expirado',
  },
  inviteModal: {
    title: 'Convidar membro',
    emailLabel: 'E-mail',
    roleLabel: 'Papel',
    cta: 'Enviar convite',
    success: 'Convite criado!',
    successHint:
      'Enviamos o convite por e-mail quando disponível; você também pode copiar o link abaixo. Ele tem 7 dias pra aceitar.',
    copyCta: 'Copiar link',
    copied: 'Copiado',
    closeCta: 'Fechar',
    emailRequired: 'O e-mail é obrigatório.',
    emailInvalid: 'Informe um e-mail válido.',
    roleRequired: 'Escolha um papel pro novo membro.',
  },
  roles: {
    administrator: 'Administrador',
    manager: 'Gerente',
    member: 'Membro',
  },
  actions: {
    changeRole: 'Mudar papel',
    remove: 'Remover da equipe',
    transferOwnership: 'Transferir propriedade',
    cancelInvitation: 'Cancelar convite',
    resendInvitation: 'Reenviar convite',
    resetPassword: 'Resetar senha',
    memberActions: 'Ações do membro',
  },
  confirmRemove: {
    title: 'Remover membro',
    message:
      'Esta pessoa perde o acesso ao estúdio imediatamente. Você pode convidá-la novamente depois.',
    confirmCta: 'Remover',
    cancelCta: 'Cancelar',
  },
  confirmTransfer: {
    title: 'Transferir propriedade',
    message:
      'Você continua como administrador, mas esta pessoa passa a ser o novo dono do estúdio. Continuar?',
    confirmCta: 'Transferir',
    cancelCta: 'Cancelar',
  },
  confirmResetPassword: {
    title: 'Resetar senha',
    message: 'Isso envia um email para a pessoa redefinir a senha. Continuar?',
    confirmCta: 'Resetar senha',
    cancelCta: 'Cancelar',
  },
  toasts: {
    inviteSuccess: 'Convite enviado com sucesso.',
    inviteError: 'Não foi possível criar o convite. Tente novamente.',
    cancelInvitationSuccess: 'Convite cancelado.',
    cancelInvitationError:
      'Não foi possível cancelar o convite. Tente novamente.',
    resendSuccess: 'Convite reenviado com um novo link.',
    removeMemberSuccess: 'Membro removido da equipe.',
    removeMemberError: 'Não foi possível remover o membro. Tente novamente.',
    changeRoleSuccess: 'Papel do membro atualizado.',
    changeRoleError: 'Não foi possível alterar o papel. Tente novamente.',
    transferOwnershipSuccess: 'Propriedade transferida com sucesso.',
    transferOwnershipError:
      'Não foi possível transferir a propriedade. Tente novamente.',
    resetPasswordSuccess: 'Email de redefinição enviado.',
    linkCopied: 'Link do convite copiado pra área de transferência.',
    linkCopyError: 'Não foi possível copiar o link. Copie manualmente.',
  },
  acceptPage: {
    states: {
      loading: 'Carregando convite...',
      invalid: {
        title: 'Convite inválido',
        message: 'Este link não é válido.',
        backCta: 'Voltar pro login',
      },
      expired: {
        title: 'Convite expirado',
        message:
          'Este convite expirou. Solicite um novo ao administrador do estúdio.',
        backCta: 'Voltar pro login',
      },
      canceled: {
        title: 'Convite cancelado',
        message: 'Este convite foi cancelado pelo administrador do estúdio.',
        backCta: 'Voltar pro login',
      },
      accepted: {
        title: 'Convite já aceito',
        message: 'Este convite já foi aceito anteriormente.',
        goAppCta: 'Ir pro app',
      },
      notLogged: {
        title: 'Aceitar convite',
        message:
          'Crie sua conta ou faça login com {{email}} pra aceitar o convite. Use exatamente esse e-mail.',
        signupCta: 'Criar conta',
        loginCta: 'Já tenho conta',
      },
      emailMismatch: {
        title: 'E-mail não corresponde',
        message:
          'Este convite foi enviado pra outro e-mail. Faça logout e entre com a conta correta.',
        logoutCta: 'Sair',
      },
      ready: {
        title: 'Aceitar convite pra {{tenantName}}',
        message: 'Você foi convidado pra {{tenantName}} como {{role}}.',
        acceptCta: 'Aceitar convite',
      },
    },
    toasts: {
      acceptSuccess: 'Convite aceito com sucesso!',
      acceptError: 'Não foi possível aceitar o convite. Tente novamente.',
    },
  },
};

export default teamTranslatePTBR;
